import {
  LoadFewCoursesAsync,
  LoadLecturersAsync,
  ShowMyCartSummaryAsync,
  MarkCoursesOccupancyAsync,
  MarkMyCoursesAsync,
  asyncsleep,
} from './aka.js';
export async function mainaka() {
  console.log('load index courses');

  console.log('LoadCourses');
  await LoadFewCoursesAsync();
  await asyncsleep(1);
  await MarkCoursesOccupancyAsync();
  await asyncsleep(1);
  await MarkMyCoursesAsync();
  await ShowMyCartSummaryAsync();
  // await LoadLecturersAsync();
}
